<template>
  <div class="legs-container">
    <LegCard
      v-for="(leg, index) in legs"
      :key="index"
      :leg="leg"
      :journey="journey"
      :direction="direction"
      :selectedSeats="getSelectedSeatsForLeg(leg, direction)"
      :seatChangePrice="getSeatChangePrice(index, direction)"
      :formatDate="formatDate"
      :formatPrice="formatPrice"
      :openSeatSelection="() => openSeatSelection(leg, direction)"
      :hasLayoutError="legLayoutErrors[getLayoutKey(leg)]"
    />
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import type { PropType } from 'vue'
  import type { Journey, Leg } from '@/types/journeyTypes'
  import LegCard from './LegCard.vue'

  export default defineComponent({
    name: 'LegsContainer',
    components: {
      LegCard
    },
    props: {
      legs: {
        type: Array as PropType<Leg[]>,
        required: true
      },
      journey: {
        type: Object as PropType<Journey>,
        required: true
      },
      direction: {
        type: String as PropType<'outbound' | 'inbound'>,
        required: true
      },
      getSelectedSeatsForLeg: {
        type: Function as PropType<(leg: Leg, direction: 'outbound' | 'inbound') => any[]>,
        required: true
      },
      getSeatChangePrice: {
        type: Function as PropType<(index: number, direction: 'outbound' | 'inbound') => number>,
        required: true
      },
      formatDate: {
        type: Function as PropType<(date: string) => string>,
        required: true
      },
      formatPrice: {
        type: Function as PropType<(price: number) => string>,
        required: true
      },
      openSeatSelection: {
        type: Function as PropType<(leg: Leg, direction: 'outbound' | 'inbound') => void>,
        required: true
      },
      isLoading: {
        type: Boolean,
        required: true
      },
      legLayoutErrors: {
        type: Object as PropType<{ [key: string]: boolean }>,
        required: true
      },
      getLayoutKey: {
        type: Function as PropType<(leg: Leg) => string>,
        required: true
      }
    }
  })
</script>

<style lang="scss" scoped>
  .legs-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
</style>
